const pixleeURL = 'https://distillery.pixlee.co';

export { pixleeURL };
